module.exports = __webpack_public_path__ + "img/file-upload-placeholder.e8a2c72b.svg";